"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var job_def_1 = require("../../../shared/job.def");
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/job/{job_id}.json', {
    description: 'Get information on a single job',
    method: 'get',
    summary: 'Job Information',
    tags: ['Job'],
    params: [
        {
            $ref: '#/components/parameters/ikeDepartmentId',
        },
        {
            $ref: '#/components/parameters/jobIdPath',
        },
    ],
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: job_def_1.job,
    },
    (0, api_response_def_1.generateValidationError)(),
]);
//# sourceMappingURL=job.get.schema.js.map